import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Provider } from 'react-redux'
import { store } from './store'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/LoginPage'
import AppPage from './pages/AppPage'
// New route structure pages
import CasePage from './pages/CasePage'
import QuickCheckHomePage from './pages/QuickCheckHomePage'
import DocumentsPage from './pages/DocumentsPage'
// DocumentViewerPage removed - document viewing is now inline in DocumentsPage
import IncomeVerificationPage from './pages/IncomeVerificationPage'
import ComingSoonWorkflow from './pages/workflows/ComingSoonWorkflow'
import NewCasePage from './pages/NewCasePage'
import './App.css'

function App() {
  return (
    <Provider store={store}>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            {/* Extract app - work items list */}
            <Route
              path="/extract" 
              element={
                <ProtectedRoute>
                  <AppPage />
                </ProtectedRoute>
              }
            />
            {/* Specific work item viewer */}
            <Route
              path="/extract/work/:workId"
              element={
                <ProtectedRoute>
                  <AppPage />
                </ProtectedRoute>
              }
            />
            {/* Document viewer (legacy) */}
            <Route
              path="/extract/document/:documentId"
              element={
                <ProtectedRoute>
                  <AppPage />
                </ProtectedRoute>
              }
            />

            {/* Quick Check - Home page with all cases */}
            <Route
              path="quick-check"
              element={
                <ProtectedRoute>
                  <QuickCheckHomePage />
                </ProtectedRoute>
              }
            />

            {/* Quick Check - Create new case */}
            <Route
              path="quick-check/new"
              element={
                <ProtectedRoute>
                  <NewCasePage />
                </ProtectedRoute>
              }
            />

            {/* Quick Check - Individual case view */}
            <Route
              path="quick-check/:caseId"
              element={
                <ProtectedRoute>
                  <CasePage />
                </ProtectedRoute>
              }
            >
              {/* Documents */}
              <Route path="documents" element={<DocumentsPage />} />
              <Route path="documents/:documentId" element={<DocumentsPage />} />

              {/* Analysis Workflows */}
              <Route path="income/*" element={<IncomeVerificationPage />} />
              <Route path="cashflow" element={<ComingSoonWorkflow name="Cash Flow Analysis" />} />
              <Route path="assets" element={<ComingSoonWorkflow name="Assets" />} />
              <Route path="debt" element={<ComingSoonWorkflow name="Debt" />} />

              {/* Default redirect to documents */}
              <Route index element={<Navigate to="documents" replace />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </Provider>
  )
}

export default App